import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { PaymentMethodType } from '@mopla/data-models';
import {
	CreditCardIcon,
	EMlpIconTypes,
	EMplVariantTypes,
	MplIconMessage,
	MplRadioButton,
	SepaIcon,
} from '@mopla/ui';

export interface IStep2FormValues {
	paymentMethod: PaymentMethodType | undefined;
}

export const Step2SelectPaymentMethod = () => {
	const { t } = useTranslation('subscribeDTicket');
	const { control } = useFormContext<IStep2FormValues>();

	return (
		<Stack gap={2}>
			<Typography variant="h4-sb" color="primary.main">
				{t('step2.title')}
			</Typography>

			<Controller
				name="paymentMethod"
				control={control}
				render={({ field }) => (
					<Stack gap={2}>
						<MplRadioButton
							text={t('step2.sepa')}
							icon={<SepaIcon />}
							checked={field.value === 'sepa'}
							onChange={() => field.onChange('sepa')}
							value="sepa"
							dataTestId="subscribeDTicket-step2SelectPaymentMethod-sepa-radioButton"
						/>
						<MplRadioButton
							text={t('step2.other')}
							icon={<CreditCardIcon />}
							checked={field.value === 'other'}
							onChange={() => field.onChange('other')}
							value="other"
							dataTestId="subscribeDTicket-step2SelectPaymentMethod-otherMethod-radioButton"
						/>
					</Stack>
				)}
			/>

			<Stack
				gap={2}
				sx={{
					marginTop: 1,
					'& .MuiTypography-root': {
						fontSize: '12px',
						lineHeight: 1.5,
					},
				}}
			>
				<MplIconMessage
					type={EMlpIconTypes.Information}
					variant={EMplVariantTypes.Default}
					message={t('step2.info_payment_warning')}
				/>
				<MplIconMessage
					type={EMlpIconTypes.Information}
					variant={EMplVariantTypes.Default}
					message={t('step2.info_data_security')}
				/>
			</Stack>
		</Stack>
	);
};
